// src/utils/notificationRoute.ts
//
// Where clicking a notification goes — one answer for every place a notification is shown (the
// redesign bell, the legacy header dropdown, the /notifications page), so a new kind of notification
// cannot work in one and dead-end in another.

import { isSafeInAppPath } from './safeInAppPath';

export interface RoutableNotification {
    /** A server-chosen in-app route, e.g. '/enquiries?enquiry=…'. Honoured only when same-site. */
    link?: string;
    applicationId?: string;
    councilSlug?: string;
    addressId?: string;
}

/**
 * The route for a notification, or undefined when it names nowhere. Precedence: the server's
 * `link` (safe same-site paths only), then the DA (councilSlug + applicationId), then the address.
 */
export function notificationRoute(n: RoutableNotification): string | undefined {
    if (n.link && isSafeInAppPath(n.link)) return n.link;
    if (n.applicationId && n.councilSlug) {
        return `/development-application/${n.councilSlug}/${encodeURIComponent(n.applicationId)}`;
    }
    if (n.addressId) return `/address/${n.addressId}`;
    return undefined;
}

/** A notification that is not about a development application (e.g. a marketplace enquiry). */
export function isNonDaNotification(n: { notificationType?: string; applicationId?: string; applicationNumber?: string; location?: string }): boolean {
    if (n.notificationType === 'enquiry') return true;
    return !n.applicationId && !n.applicationNumber && !n.location;
}
